import i18n from '../../translations';

export const computeProductFieldErrors = (field: any, basket: any) => {
  const { strings = {}, minCount, required } = field;
  if (required && !basket?.length) {
    return [
      {
        key: 'products:required',
        message: strings['no-products'] || i18n.t('product.errors.no-products'),
      },
    ];
  }

  if (minCount !== undefined && (basket?.length || 0) < minCount) {
    return [
      {
        key: 'products:minCount',
        message: strings['not-enough-products'] || i18n.t('product.errors.not-enough-products'),
      },
    ];
  }
};
